import '@angular/compiler';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageResearcherItemComponent } from './page.researcher.item/page.researcher.item.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalChatbotComponentChatbotComponent } from './portal.chatbot.component.chatbot/portal.chatbot.component.chatbot.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PortalAdminUploadComponent } from './portal.admin.upload/portal.admin.upload.component';
import { PageOrganizationItemComponent } from './page.organization.item/page.organization.item.component';
import { PageAdminComponent } from './page.admin/page.admin.component';
import { PortalAdminUploadlogComponent } from './portal.admin.uploadlog/portal.admin.uploadlog.component';
import { PageSearchComponent } from './page.search/page.search.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalAdminOrgComponent } from './portal.admin.org/portal.admin.org.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PageResearcherDiscoveryComponent } from './page.researcher.discovery/page.researcher.discovery.component';
import { PortalAdminDataComponent } from './portal.admin.data/portal.admin.data.component';
import { LayoutKorenetComponent } from './layout.korenet/layout.korenet.component';
import { PortalAdminUsersComponent } from './portal.admin.users/portal.admin.users.component';
import { PortalKorenetOrganizationDetailComponent } from './portal.korenet.organization.detail/portal.korenet.organization.detail.component';
import { PortalAdminResearcherComponent } from './portal.admin.researcher/portal.admin.researcher.component';
import { PortalAdminVectorComponent } from './portal.admin.vector/portal.admin.vector.component';
import { PortalAdminCacheComponent } from './portal.admin.cache/portal.admin.cache.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalAdminMemoryComponent } from './portal.admin.memory/portal.admin.memory.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { RouterModule } from '@angular/router';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutKorenetComponent,
        "children": [
            {
                "path": "researcher/:id/:tab?",
                component: PageResearcherItemComponent,
                "app_id": "page.researcher.item"
            },
            {
                "path": "",
                component: PageHomeComponent,
                "app_id": "page.home"
            },
            {
                "path": "signup",
                component: PageSignupComponent,
                "app_id": "page.signup"
            },
            {
                "path": "organization/:id",
                component: PageOrganizationItemComponent,
                "app_id": "page.organization.item"
            },
            {
                "path": "admin/:category?/:sub?/:detail?",
                component: PageAdminComponent,
                "app_id": "page.admin"
            },
            {
                "path": "search",
                component: PageSearchComponent,
                "app_id": "page.search"
            },
            {
                "path": "researcher-discovery",
                component: PageResearcherDiscoveryComponent,
                "app_id": "page.researcher.discovery"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }